<div class="dialog-wrapper">
  <div class="c-dialog-content c-text-dialog">
    <p-scrollPanel [style]="{ width: '100%', height: '295px' }" styleClass="c-scrollbar">
      <h2>Terms and conditions</h2>
      <div class="inner-html-content" [innerHTML]="pagesContainerContent"></div>

    </p-scrollPanel>

  </div>
  <div class="c-dialog-actions">
    <button (click)="closeDialog()" pButton pRipple
      class="c-button light cancel">{{dialogData.cancelBtnText || 'Cancel'}}</button>
    @if (dialogData.approveBtnText) {
    <button (click)="agreeAndClose()" pButton pRipple class="c-button green save">{{dialogData.approveBtnText}} <img
        class="ml-10-px" src="./../../../../assets/images/icons/arrow-right-white.svg" alt=""> </button>
    }
  </div>
</div>
